// extracted by mini-css-extract-plugin
module.exports = {"error_window":"GlobalErrors_error_window__19yxD"};